import React, {useEffect} from "react"
import { AppWrapper } from "../components/AppWrapper"
import { Home } from "../components/Home"
import firebase from "gatsby-plugin-firebase"

export default function IndexPage({ location }) {

  useEffect(() => {
    if (!firebase) {
      return;
    }
    console.log(firebase)
    firebase.analytics()
  }, [firebase]);
  
  return (
    <AppWrapper>
      <Home {...{ location: location.pathname }} />
    </AppWrapper>
  )
}